import { Component, OnInit, AfterViewInit, ChangeDetectorRef, ElementRef, Inject, OnDestroy, ViewChild } from '@angular/core';
import { SecurityService} from '../../security/security.service';
import { DataService } from 'src/app/shared/data.service';
import { MatDialog } from '@angular/material/dialog';
import { DialogWithCloseButtonComponent } from '../../utils/dialog-with-close-button/dialog-with-close-button.component';
import { Router } from '@angular/router';

@Component({
    selector: 'app-payment',
    templateUrl: './payment.component.html',
    styleUrls: ['./payment.component.scss'],
    standalone: false
})
export class PaymentComponent implements OnInit, OnDestroy, AfterViewInit {

  buttonSelected: string = "Home";

  paymentData = {
    amount:'',
    payee:'',
    items: [{ id: "xl-tshirt" }]
  }

    popMsg = {
    'title':'',
    'message':''
  }


  constructor(
    private cd: ChangeDetectorRef, 
    private svcs: SecurityService, 
    public dataSvc: DataService,
    private router: Router, 
    public dialog:MatDialog,) {
  }


  ngOnInit(): void {
    
    this.paymentData = this.dataSvc.getSharedData();
    
    this.svcs.createStripePaymentIntent(this.paymentData).subscribe(
      res => {
        console.log("PaymentIntent Creation Success - Res : " + res);

        this.clientSecret = res.clientSecret;

        console.log("Stripe CS : " + this.clientSecret);
        return;

      },
      err => {
        console.log("Payment Intent Creation Failed" + JSON.stringify(err));
        return;
      });     
      

  }

  @ViewChild('cardInfo') cardInfo: ElementRef;
  _totalAmount: number;
  card: any;
  cardHandler = this.onChange.bind(this);
  cardError: string;
  clientSecret: string;
  dialogRef;


  ngOnDestroy() {
    if (this.card) {
      // We remove event listener here to keep memory clean
      this.card.removeEventListener('change', this.cardHandler);
      this.card.destroy();
    }
  }

  ngAfterViewInit() {
    this.initiateCardElement();
  }

  initiateCardElement() {
    // Giving a base style here, but most of the style is in scss file
    const cardStyle = {
      base: {
        border: 1,
        color: '#32325d',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
          color: '#aab7c4',
        },
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a',
      },
    }; 
    
    this.card = elements.create('card', cardStyle);
    this.card.mount(this.cardInfo.nativeElement);
    this.card.addEventListener('change', this.cardHandler);
  }

  onChange({ error }) {
    if (error) {
      this.cardError = error.message;
    } else {
      this.cardError = null;
    }
    this.cd.detectChanges();
  }

  async createStripeToken() {
    const { token, error } = await stripe.createToken(this.card);
    if (token) {
      this.onSuccess(token);
    } else {
      this.onError(error);
    }
  }

  onSuccess(token) {
  }
  
  onError(error) {
    if (error.message) {
      this.cardError = error.message;
    }
  }

  openDialog(popupMessage){
    this.dialogRef = this.dialog.open(DialogWithCloseButtonComponent, {data: popupMessage});
    return;
  }


  confirmPayment(){
    stripe.confirmCardPayment(this.clientSecret, {payment_method: {card: this.card}}).then(
        (result)=>{
          this.popMsg.message = "Payment is successfully processed. Thank you!";
          this.openDialog(this.popMsg);
          console.log("Payment successful: " + JSON.stringify(result));
          this.dialogRef.afterClosed().subscribe(result => {this.router.navigate(['/reception']);});
          
        }).catch((error)=>{
          this.popMsg.message = "Payment failed. Please try again.";
          this.openDialog(this.popMsg);
          console.log("Promise rejected with " + JSON.stringify(error));
        });
        /*function(result) {
          if (result.error) {
          } else {
            console.log('Confirm Payment Result:' + JSON.stringify(result));
          }});*/

    //const result = await stripe.confirmCardPayment(this.clientSecret, {payment_method: {card: this.card}});
    //console.log(result);

  }

  cancel(){
    this.router.navigate(['/reception']);
  }
}
